var React = require('react');

function Download (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"download","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("path",{"d":"M22,20.314057 L27.9970732,14.3772784 L33.5563492,19.8806613 L24.3374505,29.0068731 L24.3840118,29.0529662 L18.8247359,34.5563492 L18.7781746,34.510256 L18.7316133,34.5563492 L13.1723374,29.0529662 L13.2188986,29.0068731 L4,19.8806613 L9.55927595,14.3772784 L14,18.7733554 L14,4 L22,4 L22,20.314057 Z","id":"Combined-Shape","fill":"currentColor","fillRule":"nonzero"})));
}

Download.defaultProps = {"width":"38px","height":"38px","viewBox":"0 0 38 38","version":"1.1"};

module.exports = Download;

Download.default = Download;
